import { utils, PLAN_LEARN_MORE_DIALOG as PlanLearnMoreDialog } from '@zoom/billing-shared'

export default {
  data () {
    return {
      featureKeys: {
        zoomWorkFlowAutomation: 'ZOOM_WORK_FLOW_AUTOMATION_DIALOG'
      }
    };
  },
  computed: {
  },
  methods: {
    async openDialogInCommon (key) {
      if (!window.__ZM_BILLING_SHARED?.utils?.showDialog) {
        return;
      }
      try {
        const dialog = window.__ZM_BILLING_SHARED[key];
        dialog && window.__ZM_BILLING_SHARED.utils.showDialog(dialog, { visible: true });
      } catch (error) {
        console.error('Failed to load dialog module:', error);
      }
    },
    openPlanLearnMoreDialog(planType, planConfig = {}){
      if (!utils?.showDialog) {
        return
      }
      try {
        PlanLearnMoreDialog &&
        utils.showDialog(PlanLearnMoreDialog, {
          visible: true,
          planType,
          planConfig: { ...planConfig }
        })
      } catch (error) {
        console.error('Failed to load dialog module:', error)
      }
    }
  }
};
